import { SERVER_API } from "../../Constant";
import axios from "axios";

export const UpdateInquiry_api = async (inputs: any) => {
  try {
    const data = new FormData();
    data.append("inputs", JSON.stringify(inputs));
    const response = await axios.post(
      `${SERVER_API}/Payments/update_inquiry.php`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Update inquiry failed:", error);
    return { error: "Update inquiry failed" };
  }
};
